<template>
  <div>
    <div>
      <span class="xbed-sub-title">物品管理</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>麗家会</BreadcrumbItem>
        <BreadcrumbItem>物品管理</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <Tabs class="tabs" @on-click="changeTab" style="width:2185px;">
      <TabPane label="物品列表" name="goodsList" ref="goodsList">
        <Form @submit.native.prevent="preventSubmit" :model="goodsList.form" :rules="goodsList.rules" inline>
          <Row>
            <FormItem prop="goodsName" label="物品名称：" :label-width="84">
              <Input type="text" :maxlength="100" v-model="goodsList.form.goodsName"></Input>
            </FormItem>

            <FormItem prop="stockNumber" label="产品编号：" :label-width="84">
              <Input type="text" :maxlength="100" v-model="goodsList.form.stockNumber"></Input>
            </FormItem>

            <FormItem label="类别：" :label-width="84">
              <Cascader v-model="goodsList.form.selectedGoodsType" :data="goodsList.goodsTypeList" :load-data="loadGoodsTypeData"></Cascader>
            </FormItem>

            <FormItem prop="isStandard" label="是否标配：" :label-width="84">
              <Select v-model="goodsList.form.isStandard" filterable>
                <Option value="S00">全部</Option>
                <Option :value="1">标配</Option>
                <Option :value="0">选配</Option>
              </Select>
            </FormItem>

            <FormItem prop="goodsAttribute" label="属性：" :label-width="80">
              <Select v-model="goodsList.form.goodsAttribute" filterable>
                <Option value="S00">全部</Option>
                <Option value="布草">布草</Option>
                <Option value="易耗品">易耗品</Option>
              </Select>
            </FormItem>
          </Row>

          <FormItem prop="checkType" label="核查类型：" :label-width="84">
            <Select v-model="goodsList.form.checkType" filterable>
              <Option value="S00">全部</Option>
              <Option :value="0">不核查</Option>
              <Option :value="1">数量标准</Option>
              <Option :value="2">步骤标准</Option>
              <Option :value="3">数量+步骤</Option>
            </Select>
          </FormItem>

          <FormItem prop="terminal" label="应用终端：" :label-width="84">
            <Select v-model="goodsList.form.terminal" filterable>
              <Option :value="-1">全部</Option>
              <Option :value="1">xbed</Option>
              <Option :value="2">房东端</Option>
              <Option :value="3">xbed+房东端</Option>
            </Select>
          </FormItem>

          <FormItem prop="hotelQuery">
            <Button type="primary" @click="queryCleanerGoodsListWithKeyword">查询</Button>
          </FormItem>

          <FormItem prop="addHotel">
            <Button type="primary" @click="() => {openEditGoodsModal('add')}">新增物品</Button>
          </FormItem>

        </Form>
        <Table stripe :loading="goodsList.loading" :columns="goodsList.columns" :data="goodsList.data"></Table>
        <div style="float: left;margin: 10px;overflow: hidden">
          <Page show-sizer placement="top" :total="goodsList.count" :current="goodsList.page" :page-size="goodsList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </TabPane>
      <TabPane label="易耗品费用设置" name="consumables" ref="consumables">
        <consumables-setting :consumableData="consumableData" @onQueryConsumablesList="queryConsumablesList"></consumables-setting>
      </TabPane>
      <TabPane label="布草洗涤费设置" name="washingFee" ref="washingFee">
        <washing-feeds :washingData="washingData" @onQueryWashingList="queryWashingList"></washing-feeds>
      </TabPane>
    </Tabs>

    <Modal v-model="editGoodsModal.display" :title="editGoodsModal.title" ref="editGoodsModal" :loading="true" @on-ok="preEditGoods">
      <Form :model="editGoodsModal.form" ref="editGoodsModalForm" :rules="editGoodsModal.rules" :label-width="96">
        <FormItem v-if="editGoodsModal.form.id" label="物品id：" prop="id">
          <Input :value="editGoodsModal.form.id" disabled></Input>
        </FormItem>

        <FormItem label="物品名称：" prop="goodsName">
          <Input :maxlength="100" v-model="editGoodsModal.form.name"></Input>
        </FormItem>

        <FormItem label="进销存产品id：" prop="jxcGoodsId" v-if="editGoodsModal.form.jxcGoodsId">
          <Input :maxlength="100" v-model="editGoodsModal.form.jxcGoodsId" disabled></Input>
        </FormItem>

        <FormItem label="进销存产品编号：" prop="stockNumber">
          <Input :maxlength="100" v-model="editGoodsModal.form.stockNumber"></Input>
        </FormItem>

        <FormItem label="类别：" prop="selectedGoodsType">
          <Cascader v-model="editGoodsModal.form.selectedGoodsType" :data="editGoodsModal.goodsTypeList" :load-data="loadGoodsTypeData"></Cascader>
        </FormItem>

        <FormItem label="型号/品牌：" prop="goodsModel">
          <Input :maxlength="100" v-model="editGoodsModal.form.goodsModel"></Input>
        </FormItem>

        <FormItem label="规格：" prop="goodsDesc">
          <Input v-model="editGoodsModal.form.goodsDesc"></Input>
        </FormItem>

        <FormItem prop="isStandard" label="是否标配：">
          <Select v-model="editGoodsModal.form.isStandard" transfer filterable>
            <Option :value="1">标配</Option>
            <Option :value="0">选配</Option>
          </Select>
        </FormItem>

        <FormItem prop="goodsAttribute" label="属性：">
          <Select v-model="editGoodsModal.form.goodsAttribute" filterable transfer>
            <Option value="S00">无</Option>
            <Option value="布草">布草</Option>
            <Option value="易耗品">易耗品</Option>
          </Select>
        </FormItem>

        <FormItem prop="terminal" label="应用终端：">
          <Select v-model="editGoodsModal.form.terminal" filterable transfer>
            <Option :value="1">xbed</Option>
            <Option :value="2">房东端</Option>
            <Option :value="3">xbed+房东端</Option>            
          </Select>
        </FormItem>

        <FormItem prop="remark" label="备注：">
          <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" :maxlength="255" v-model="editGoodsModal.form.remark"></Input>
        </FormItem>

      </Form>
    </Modal>

    <Modal v-model="checkSettingModal.display" title="设置核查" ref="checkSettingModal" :width="1000" :loading="true" @on-ok="preEditCheck">
      <Form :model="checkSettingModal.form"  :label-width="84">
        <FormItem label="物品" prop="name">
          <Input :value="checkSettingModal.form.name" disabled></Input>
        </FormItem>

        <FormItem label="图片" prop="picture">
          <img v-show="checkSettingModal.form.checkPic" :src="checkSettingModal.form.checkPic" alt="" style="width:100%">
          <Upload v-if="!checkSettingModal.form.checkPic" action="//upload.qiniup.com" name="file" :format="['jpg']" :max-size="5242" :data="checkSettingModal.uploadData" :before-upload="beforeUpload" :on-success="uploadSuccess" :on-format-error="imgFormatError" :show-upload-list="false">
            <Button type="primary" icon="ios-cloud-upload-outline">添加图片</Button>
          </Upload>
          <Button v-if="checkSettingModal.form.checkPic" type="error" @click="clearCheckPic">删除图片</Button>
        </FormItem>

        <FormItem label="核查类型" prop="checkType">
          <Select v-model="checkSettingModal.form.checkType" placement="top" transfer filterable>
            <Option :value="0">不核查</Option>
            <Option :value="1">数量标准</Option>
            <Option :value="2">步骤标准</Option>
            <Option :value="3">数量+步骤</Option>
          </Select>
        </FormItem>

        <FormItem v-if="checkSettingModal.form.checkType == 1 || checkSettingModal.form.checkType == 3" label="数量" prop="unit">
          <span style="font-size: 14px;">管家需要填写房间物品的数量</span>
        </FormItem>

        <FormItem v-if="checkSettingModal.form.checkType == 2 || checkSettingModal.form.checkType == 3" label="步骤标准" prop="checkOptions">
          <div class="check-step" v-for="(options, index) in checkSettingModal.form.checkOptions" :key="index">
            <span>{{`${index+1}、`}}</span>
            <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" :maxlength="200" v-model="options.remark"></Input>
            <span v-show="checkSettingModal.form.checkOptions.length > 1" class="remove-step" @click="removeStep(index)"><Icon type="minus-round"></Icon></span>
          </div>
          <div class="add-step" @click="addStep"><Icon type="plus-round"></Icon></div>
        </FormItem>

      </Form>
    </Modal>
  </div>
</template>

<script>
import Utils from "@/utils";
import API from "@/api";
import {STORE_KEY} from "../../constants";
import ConsumablesSetting from "./consumables-setting";
import WashingFeeds from "./washing-feeds";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });

    this.getSelectiveForCleanerGoodsList();

    this.queryCleanerGoodsList();
  },
  data() {
    const validateGoodsList = {
      goodsName: (rule, value, callback) => {
        if (!this.editGoodsModal.form.name) {

          callback(new Error('物品名称不能为空'))
        } else if (this.editGoodsModal.form.name.length > 100) {

          callback(new Error('物品名称不能超过100字'))
        } else {
          callback();
        }
      },
      selectedGoodsType: (rule, value, callback) => {
        if (this.editGoodsModal.form.selectedGoodsType.length === 0) {
          callback(new Error('请选择类别'))
        } else {
          callback();
        }
      },
    };

    return {
      washingData: {},
      consumableData: {},
      goodsList: {
        goodsTypeList: [],
        form: {
          goodsName: '',
          stockNumber:'',
          isStandard: 'S00',
          goodsAttribute: 'S00',
          checkType: 'S00',
          selectedGoodsType: [],
          terminal:-1
        },
        loading: false,
        columns: [
          {
            title: "物品id",
            key: "goodsId",
            align: "center",
            width: 150,
          },
          {
            title: "物品名称",
            key: "goodsName",
            align: "center",
            width: 150,
          },
          {
            title: "进销存产品id",
            key: "jxcGoodsId",
            align: "center",
            width: 130,
          },
          {
            title: "进销存产品编号",
            key: "stockNumber",
            align: "center",
            width: 200,
          },
          {
            title: "一级类别",
            key: "catalogName",
            align: "center",
            width: 150
          },
          {
            title: "二级类别",
            key: "secondaryCatalogName",
            align: "center",
            width: 150,
          },
          {
            title: "型号/品牌",
            key: "goodsModel",
            align: "center",
            width: 150,
          },
          {
            title: "规格",
            key: "goodsDesc",
            align: "center",
            width: 150,
          },
          {
            title: "是否标配",
            key: "isStandard",
            align: "center",
            width: 150,
            render: (h, params) => {

              return h('div', {}, params.row.isStandard === 1 ? '标配' : '选配');
            }
          },
          {
            title: "属性",
            key: "goodsAttribute",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h('div', {}, params.row.goodsAttribute);
            }
          },
          {
            title: "应用终端",
            key: "terminal",
            align: "center",
            width: 150,
            render: (h, params) => {
              const terminalarr = ['', 'xbed', '房东端', 'xbed+房东端']
              return h('div', {}, terminalarr[params.row.terminal]);
            }
          },
          {
            title: "备注",
            key: "remark",
            align: "center",
            width: 150,
          },
          {
            title: "核查类型",
            key: "checkType",
            align: "center",
            width: 150,
            render: (h, params) => {
              let checkType = '';
              switch(params.row.checkType) {
                case 0:
                  checkType = '不核查';
                  break;
                case 1: 
                  checkType = '数量标准';
                  break;
                case 2:
                  checkType = '步骤标准';
                  break;
                case 3:
                  checkType = '数量+步骤'
                  break;
              }

              return h('div', {}, checkType);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      margin: "5px"
                    },
                    on: {
                      click: () => {
                        const row = params.row;

                        // 初始化类别
                        const secondaryCatalog = row.secondaryCatalog ? row.secondaryCatalog : -1;
                        let selectedGoodsType = [row.goodsCatalog, secondaryCatalog]

                        // 属性
                        const goodsAttribute = row.goodsAttribute ? row.goodsAttribute : 'S00'

                        const paramsForm = {
                          id: row.goodsId,
                          name: row.goodsName,
                          selectedGoodsType,
                          goodsModel: row.goodsModel,
                          goodsDesc: row.goodsDesc,
                          isStandard: row.isStandard,
                          terminal: row.terminal,                          
                          goodsAttribute,
                          remark: row.remark,
                          stockNumber: row.stockNumber,
                          jxcGoodsId: row.jxcGoodsId,
                        }
                        this.openEditGoodsModal('edit', paramsForm);
                      }
                    }
                  },
                  "修改物品"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      margin: "5px"
                    },
                    on: {
                      click: () => {
                        let checkOptions = []
                        if (!params.row.checkOptions) {
                          checkOptions.push({
                            remark: ''
                          })
                        } else {
                          checkOptions = JSON.parse(params.row.checkOptions).map((item)=>{
                            return { remark: item }
                          });
                        }

                        this.openCheckSettingModal({
                          form: {
                            id: params.row.goodsId,
                            name: params.row.goodsName,
                            checkType: +params.row.checkType,
                            unit: +params.row.unit,
                            checkOptions,
                            checkPic: params.row.checkPic
                          },
                        });
                      }
                    }
                  },
                  "核查设置"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      margin: "5px"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          render: modalH => {
                            let modalText = `物品删除后不可恢复，并将从房间和核查项目中删除，确认删除？`;
                            return modalH(
                              "div",
                              {
                                style: {
                                  fontSize: "16px"
                                }
                              },
                              modalText
                            );
                          },
                          okText: "确定删除",
                          onOk: () => {
                            this.delGoods(params.row.goodsId);
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        count: 0,
        page: 1,
        pageSize: 10,
        rules: {
          goodsName: [
            { required: false, trigger: "blur" },
            { type: 'string', max: 100, message: '物品名称不能超过100字', trigger: 'blur' }
          ]
        },
      },
      editGoodsModal: {
        goodsTypeList: [],
        display: false,
        title: '',
        form: {
          name: '',
          selectedGoodsType: [],
          goodsModel: '',
          goodsDesc: '',
          isStandard: 1,
          goodsAttribute: 'S00',
          terminal: 1,
          remark: '',
          stockNumber:'',
          jxcGoodsId:''
        },
        rules: {
          goodsName: [
            { required: true, validator: validateGoodsList.goodsName, trigger: 'blur' }
          ],
          selectedGoodsType: [
            { required: true, validator: validateGoodsList.selectedGoodsType, trigger: 'change' }
          ],
          goodsModel: [
            { required: false, trigger: "blur" },
            { type: 'string', max: 100, message: '型号/品牌不能超过255字', trigger: 'blur' }
          ],
          goodsDesc: [
            { required: false, trigger: "blur" },
            { type: 'string', max: 255, message: '规格不能超过255字', trigger: 'blur' }
          ],
        },
        editType: {
          add: 'add',
          edit: 'edit'
        }
      },
      checkSettingModal: {
        display: false,
        form: {
          name: '',
          checkType: 1,
          unit: 0,
          checkOptions: [],
          checkPic: ''
        },
        uploadData: {
          name: "",
          form: {}
        },
      }
    }
  },
  methods: {
    changePage(pageIndex) {
      this.goodsList.page = pageIndex;
      this.queryCleanerGoodsList();
    },
    changePageSize(pageSize) {
      this.goodsList.page = 1;
      this.goodsList.pageSize = pageSize;
      this.queryCleanerGoodsList();
    },
    changeTab(name) {
      switch (name) {
        case 'consumables':
          this.queryConsumablesList({
            page: 1,
            pageSize: 10,
            cityName:'',
            goodsName:''
          })
          break;
        case 'washingFee':
          this.queryWashingList({
            page: 1,
            pageSize: 10,
            cityName:'',
            goodsName:''
          })
          break;
      
        default:
          break;
      }
    },
    // 获取易耗品所有城市
    async queryConsumablesList(query) {
      const resp = (await API.omsAPI[this.env].cleaner.consumableList(query, this.token)).data;
      if(resp.retCode) {
        this.$Notice.error({
          title: '获取易耗品费用列表失败',
          desc: resp.msg
        })
        return
      }
      this.consumableData = resp;
    },
    // 获取布草所有城市
    async queryWashingList(query) {
      const resp = (await API.omsAPI[this.env].cleaner.washingList(query, this.token)).data;
      if(resp.retCode) {
        this.$Notice.error({
          title: '获取布草列表失败',
          desc: resp.msg
        })
        return
      }
      this.washingData = resp
    },
    async getSelectiveForCleanerGoodsList(params={}, currSelector) {
      const resp = (await API.omsAPI[this.env].cleaner.getSelectiveForCleanerGoodsList(params, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询物品类别下拉列表失败",
          desc: resp.msg
        });
        return
      }

      for (let index = 0; index < resp.length; index++) {
        let type = resp[index]
        type.value = type.id
        type.label = type.catalogName
        type.children = []
        type.loading = false

      }

      this.goodsList.goodsTypeList = [...resp];
      this.editGoodsModal.goodsTypeList = [...resp];

      if (params.parentId) {
        this[currSelector].secondaryCatalog = resp;
      } else {
        this.goodsList.goodsCatalog = [...resp];
        this.editGoodsModal.goodsCatalog = [...resp];
      }

    },
    // 加载二级物品类型选项
    async loadGoodsTypeData(item,callback){
      item.loading = true

      // 获取物品类别
      const resp = (await API.omsAPI[this.env].cleaner.getSelectiveForCleanerGoodsList({parentId:item.id},this.token)).data

      if(resp.retCode){
        // 失败
        this.$Notice.error({
          title: "获取物品类型失败",
          desc: resp.msg
        });
      }else{
        for (let index = 0; index < resp.length; index++) {
            let type = resp[index]
            type.value = type.id
            type.label = type.catalogName
        }
        
        resp.unshift({
          value: -1,
          label:'全部'
        })
        
        item.children = resp
      }

      item.loading = false
      callback()

    },
    queryCleanerGoodsListWithKeyword() {
      this.goodsList.page = 1;
      this.queryCleanerGoodsList();
    },
    async queryCleanerGoodsList() {
      if (!this.checkHasPermission('oms_xbclean_svGoods_list')) {
        return;
      }

      this.goodsList.loading = true;
      console.info('this.goodsList',this.goodsList)
      const resp = (await this.sendCleanerGoodsList(this.goodsList, this.token, this.env)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询物品失败",
          desc: resp.msg
        });
        return
      }

      this.goodsList.data = resp.content;
      this.goodsList.count = resp.totalCount;

      this.goodsList.loading = false;
    },
    sendCleanerGoodsList(goodsList, token, env) {

      let params = {
        page: goodsList.page,
        pageSize: goodsList.pageSize,
      };

      if (goodsList.form.selectedGoodsType.length > 0) {
        params.goodsCatalog = goodsList.form.selectedGoodsType[0]

        goodsList.form.selectedGoodsType[1] !== -1 && (params.secondaryCatalog = goodsList.form.selectedGoodsType[1]);
      }

      goodsList.form.goodsName && goodsList.form.goodsName.trim().length > 0 && (params.goodsName = goodsList.form.goodsName.trim());
      goodsList.form.stockNumber && goodsList.form.stockNumber.trim().length > 0 && (params.stockNumber = goodsList.form.stockNumber.trim());
      goodsList.form.isStandard !== 'S00' && (params.isStandard = goodsList.form.isStandard);
      goodsList.form.goodsAttribute !== 'S00' && (params.goodsAttribute = goodsList.form.goodsAttribute);
      goodsList.form.checkType !== 'S00' && (params.checkType = goodsList.form.checkType);
      goodsList.form.terminal !== '-1' && (params.terminal = goodsList.form.terminal);
      
      return API.omsAPI[env].cleaner.queryCleanerGoodsList(params, token);
    },
    async preEditGoods() {
      if (this.editGoodsModal.form.id && !this.checkHasPermission('oms_xbclean_svGoods_edit')) {
        this.$refs.editGoodsModal.buttonLoading = false;
        return;
      }
      let validResult = false;
      this.$refs.editGoodsModalForm.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        this.$refs.editGoodsModal.buttonLoading = false;
        return;
      }
      let params = {
        goodsName: this.editGoodsModal.form.name,
        goodsCatalog: this.editGoodsModal.form.selectedGoodsType[0],
        isStandard: this.editGoodsModal.form.isStandard,
        terminal: this.editGoodsModal.form.terminal,
        stockNumber: this.editGoodsModal.form.stockNumber == null ? '' : this.editGoodsModal.form.stockNumber,
      }
      if (this.editGoodsModal.form.id) {
        params.goodsId = this.editGoodsModal.form.id;
        params.updateName = this.username
      } else {
        params.createName = this.username;
      }

      this.editGoodsModal.form.selectedGoodsType[1] !== -1 && (params.secondaryCatalog = this.editGoodsModal.form.selectedGoodsType[1])
      this.editGoodsModal.form.goodsModel && (params.goodsModel = this.editGoodsModal.form.goodsModel)
      this.editGoodsModal.form.goodsDesc && (params.goodsDesc = this.editGoodsModal.form.goodsDesc)
      this.editGoodsModal.form.remark && (params.remark = this.editGoodsModal.form.remark)
      this.editGoodsModal.form.goodsAttribute !== 'S00' && (params.goodsAttribute = this.editGoodsModal.form.goodsAttribute)

      const apiName = this.editGoodsModal.form.id ? 'editGoodsForCleanerGoodsList' : 'addGoodsForCleanerGoodsList'

      const resp = (await API.omsAPI[this.env].cleaner[apiName](params, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "操作失败",
          desc: resp.msg
        });
        this.$refs.editGoodsModal.buttonLoading = false;
        return
      }

      this.$Notice.success({
        title: "操作成功"
      });
      this.queryCleanerGoodsList();
      this.editGoodsModal.display = false;
    },
    openEditGoodsModal(editType, payload) {
      this.initEditGoodsModal();
      if (editType === this.editGoodsModal.editType.add) {
        this.editGoodsModal.title = '新增物品';
      } else if (editType === this.editGoodsModal.editType.edit) {
        this.editGoodsModal.title = '修改物品';
        this.editGoodsModal = Object.assign({}, this.editGoodsModal, {
          form: payload
        });
      }

      this.editGoodsModal.display = true;
    },
    initEditGoodsModal() {
      this.editGoodsModal = Object.assign(this.editGoodsModal, {
        title: '',
        form: {
          name: '',
          selectedGoodsType: [],
          goodsModel: '',
          goodsDesc: '',
          isStandard: 1,
          terminal: 1,
          goodsAttribute: 'S00',
          remark: '',
          stockNumber:'',
          jxcGoodsId:''
        },
      })
    },
    async delGoods(goodsId) {
      if (!this.checkHasPermission('oms_xbclean_svGoods_del')) {
        return;
      }

      const resp = (await API.omsAPI[this.env].cleaner.delGoodsForCleanerGoodsList(goodsId, this.username, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "操作失败",
          desc: resp.msg
        });
        return
      }

      this.$Notice.success({
        title: "操作成功"
      });
      this.queryCleanerGoodsList();
    },
    openCheckSettingModal(payload={}) {
      this.initCheckSettingModal(payload);
      this.checkSettingModal.display = true;
    },
    initCheckSettingModal(payload) {
      this.checkSettingModal = Object.assign(this.checkSettingModal, {
        form: {
          id: '',
          name: '',
          checkType: 1,
          unit: 0,
          checkOptions: [],
          checkPic: ''
        },
        uploadData: {
          name: "",
          form: {}
        },
      }, payload)
    },
    async preEditCheck() {
      if (!this.checkHasPermission('oms_xbclean_svGoods_setGoodsCheck')) {
        this.$refs.checkSettingModal.buttonLoading = false;
        return;
      }

      const params = this.genCheckParams();

      if (params.hasOwnProperty('checkOptions') && (params.checkOptions.length === 0)) {
        this.$Notice.error({
          title: "操作失败",
          desc: '步骤标准不能为空'
        });
        this.$refs.checkSettingModal.buttonLoading = false;
        return;
      }

      const resp = (await API.omsAPI[this.env].cleaner.setGoodsCheckForCleanerGoodsList(params, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "操作失败",
          desc: resp.msg
        });
        this.$refs.checkSettingModal.buttonLoading = false;
        return
      }

      this.$Notice.success({
        title: "操作成功"
      });
      this.queryCleanerGoodsList();
      this.checkSettingModal.display = false;
    },
    genCheckParams() {
      let params = {
        goodsId: this.checkSettingModal.form.id,
        updateName: this.username,
        checkType: this.checkSettingModal.form.checkType
      }

      if (this.checkSettingModal.form.checkPic) {
        params.checkPic = this.checkSettingModal.form.checkPic;
      }

      if (this.checkSettingModal.form.checkType === 1) {
        params.unit = this.checkSettingModal.form.unit;
      } else if (this.checkSettingModal.form.checkType === 2) {

        params.checkOptions = this.genCheckOptions(this.checkSettingModal.form.checkOptions);
      } else if (this.checkSettingModal.form.checkType === 3) {

        params.unit = this.checkSettingModal.form.unit;
        params.checkOptions = this.genCheckOptions(this.checkSettingModal.form.checkOptions);
      }

      return params
    },
    genCheckOptions(options) {
      let checkOptions = [];
      for (let i=0; i<options.length; i++) {
        const option = options[i];
        if (option.remark.trim().length === 0) { // 如果有一个输入框为空
          checkOptions = [];
          break;
        }
        checkOptions.push(option.remark);
      }
      
      if (checkOptions.length === 0) {
        return ''
      }
      return JSON.stringify(checkOptions);
    },
    addStep() {
      this.checkSettingModal.form.checkOptions.push({ remark: '' });
    },
    removeStep(delIndex) {
      this.checkSettingModal.form.checkOptions.splice(delIndex, 1);
    },
    // 删除图片
    clearCheckPic() {
      this.checkSettingModal.form.checkPic = '';
    },
    // 图片上传前
    async beforeUpload(file) {
      console.info(`${file}`);
      
      const fileMaxSize = 5242880 // 图片最大上传大小

      if (file.size > fileMaxSize) {
        this.$Notice.error({
          title: "添加图片失败",
          desc: '不能选择超过5m的图片'
        });
        return false;
      }

      const token = (await API.omsAPI[this.env].common.getUploadToken(false, this.token)).data;
      this.checkSettingModal.uploadData.token = token;
      this.checkSettingModal.uploadData["x:fileDirId"] = 636;
      this.checkSettingModal.uploadData["x:isPrivate"] = 0;
      this.checkSettingModal.uploadData["x:remark"] = "新增核查图片";
      return true;
    },
    imgFormatError() {
      this.$Notice.error({
        title: "图片格式必须为jpg"
      });
    },
    uploadSuccess(resp) {
      this.checkSettingModal.form.checkPic = resp.materialBase.url;
    },
    // 权限校验
    checkHasPermission(name) {
      if(!Utils.hasPermission(name)){
        this.$Notice.error({
          title: Utils.getFromStore(STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS)
        });

        return false;
      }
      return true;
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
  },
  components: {
    consumablesSetting: ConsumablesSetting,
    washingFeeds: WashingFeeds
  }
}
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
}

.tabs {
  margin-top: 20px;
}

.table-wrapper {
  margin-top: 20px;
}

.check-step{
  display: flex;
  margin-bottom: 12px;
  .remove-step {
    margin-left: 12px;
    i { 
      padding: 4px 8px;
      color: #ed3f14;
      border: 2px solid #ed3f14;
      border-radius: 8px;
      font-size: 18px;
    }
  }
}
.add-step {
  margin-top: 18px;
  margin-left: 18px;
  i { 
    padding: 4px 8px;
    color: #2d8cf0;
    border: 2px solid #2d8cf0;
    border-radius: 8px;
    font-size: 18px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/cleaner/goods-list.vue